import { render } from "./contacts-modal.vue?vue&type=template&id=16b152b8"
import script from "./contacts-modal.vue?vue&type=script&lang=js"
export * from "./contacts-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__